<template>
  <div class="volume-holder d-flex align-items-center">
    <div class="volume-container" ref="sliderContainer">
      <div class="fill" :style="{ width: fillWidth }"></div>
      <input
        type="range"
        min="0"
        max="1"
        step="0.25"
        :value="value"
        class="volume-slider"
        @input="changed"
        ref="slider"
        @touchmove.prevent="handleTouchMove"
      >
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
  data() {
    return {
      value: 0,
      fillWidth: '0%'
    }
  },
  computed: {
    ...mapState(['volume']),
  },
  methods: {
    ...mapMutations(['setVolume']),
    
    changed(event) {
      const newValue = parseFloat(event.target.value);
      this.value = newValue;
      this.setVolume(newValue);
      this.updateFill();
    },

    updateFill() {
      let percent = this.value * 100;
      
      if (percent > 95) percent -= 5;
      if (percent < 5) percent += 5;

      this.fillWidth = percent + '%';
    },

    handleTouchMove(event) {
      const percent = this.getSteppedPercent()
      
      // snap to nearest step of 0.25
      const steppedValue = Math.round(percent / 0.25) * 0.25;
      
      this.value = steppedValue;
      this.setVolume(steppedValue);
      this.updateFill();
    },

    getSteppedPercent() {
      const touch = event.touches[0];
      const rect = this.$refs.sliderContainer.getBoundingClientRect();

      if (Config.windowHeight > Config.windowWidth) {
        const y = (rect.top + rect.height) - touch.clientY;
        return Math.min(Math.max(y / rect.height, 0), 1);
      }

      const x = touch.clientX - rect.top
      return Math.min(Math.max(x / rect.width, 0), 1);
    },
  },
  watch: {
    volume(newVolume) {
      this.value = newVolume;
      this.updateFill();
    }
  },
  mounted() {
    this.value = this.volume;
    this.updateFill();
  }
}
</script>
